import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Box,
} from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { formatMoney } from '../../../utils/currency';

const getVariation = (current, previous) => {
  if (!previous || previous === 0) return { percent: 0, trend: 'neutral' };
  const diff = current - previous;
  const percent = (diff / previous) * 100;
  return {
    percent: percent.toFixed(1),
    trend: percent > 0 ? 'up' : percent < 0 ? 'down' : 'neutral',
  };
};

const SellerPerformanceTable = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ height: 360, p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" gutterBottom>
        Rendimiento por vendedor
      </Typography>

      <Box sx={{ overflowY: 'auto', flex: 1 }}>
        {loading ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ backgroundColor: 'background.paper' }}>Vendedor</TableCell>
                <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Monto</TableCell>
                <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Ventas</TableCell>
                <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Promedio por venta</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'background.paper' }}>Rendimiento</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array(5).fill(null).map((_, i) => (
                <TableRow key={i}>
                  {Array(5).fill(null).map((_, j) => (
                    <TableCell key={j} align={j === 0 ? 'left' : 'center'}>
                      <Skeleton width={`${40 + Math.random() * 40}%`} />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : data.length > 0 ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ backgroundColor: 'background.paper' }}>Vendedor</TableCell>
                <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Monto</TableCell>
                <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Ventas</TableCell>
                <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Promedio por venta</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'background.paper' }}>Rendimiento</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((seller) => {
                const { percent, trend } = getVariation(seller.total, seller.previousTotal);
                return (
                  <TableRow key={seller.name}>
                    <TableCell>{seller.name}</TableCell>
                    <TableCell align="center">{formatMoney(seller.total)}</TableCell>
                    <TableCell align="center">{seller.ticketCount}</TableCell>
                    <TableCell align="center">
                      {typeof seller.averageTicket === 'number'
                        ? `${formatMoney(seller.averageTicket)}`
                        : '—'}
                    </TableCell>
                    <TableCell align="right">
                      {trend === 'up' ? (
                        <Box component="span" color="success.main" display="inline-flex" alignItems="center">
                          {percent}% <ArrowDropUpIcon fontSize="small" />
                        </Box>
                      ) : trend === 'down' ? (
                        <Box component="span" color="error.main" display="inline-flex" alignItems="center">
                          {percent}% <ArrowDropDownIcon fontSize="small" />
                        </Box>
                      ) : (
                        <Box component="span" color="text.secondary">0%</Box>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Box
            sx={{
              height: 300,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default SellerPerformanceTable;
